export const allTheOtherFields = [
  { label: 'Asins', value: 'asins' },
  { label: 'Brand', value: 'brand' },
  { label: 'Categories', value: 'categories' },
  { label: 'CanonicalBrand', value: 'canonicalBrand' },
  { label: 'Colors', value: 'colors' },
  { label: 'Count', value: 'count' },
  { label: 'DateAdded', value: 'dateAdded' },
  { label: 'DateUpdated', value: 'dateUpdated' },
  { label: 'Descriptions', value: 'descriptions' },
  { label: 'Dimension', value: 'dimension' },
  { label: 'Domains', value: 'domains' },
  { label: 'Ean', value: 'ean' },
  { label: 'Ean13', value: 'ean13' },
  { label: 'Ean8', value: 'ean8' },
  { label: 'Features', value: 'features' },
  { label: 'FinancingAndLeasing', value: 'financingAndLeasing' },
  { label: 'Flavors', value: 'flavors' },
  { label: 'ImageURLs', value: 'imageURLs' },
  { label: 'Isbn', value: 'isbn' },
  { label: 'Keys', value: 'keys' },
  { label: 'Manufacturer', value: 'manufacturer' },
  { label: 'ManufacturerNumber', value: 'manufacturerNumber' },
  { label: 'Merchants', value: 'merchants' },
  { label: 'MostRecentPriceAmount', value: 'mostRecentPriceAmount' },
  {
    label: 'MostRecentPriceAvailability',
    value: 'mostRecentPriceAvailability'
  },
  { label: 'MostRecentPriceByDomain', value: 'mostRecentPriceByDomain' },
  { label: 'MostRecentPriceColor', value: 'mostRecentPriceColor' },
  { label: 'MostRecentPriceCondition', value: 'mostRecentPriceCondition' },
  { label: 'MostRecentPriceCurrency', value: 'mostRecentPriceCurrency' },
  { label: 'MostRecentPriceDate', value: 'mostRecentPriceDate' },
  { label: 'MostRecentPriceDomain', value: 'mostRecentPriceDomain' },
  { label: 'MostRecentPriceIsSale', value: 'mostRecentPriceIsSale' },
  { label: 'MostRecentPriceSize', value: 'mostRecentPriceSize' },
  { label: 'MostRecentPriceSourceURL', value: 'mostRecentPriceSourceURL' },
  { label: 'Name', value: 'name' },
  { label: 'PrimaryCategories', value: 'primaryCategories' },
  { label: 'PrimaryImageURLs', value: 'primaryImageURLs' },
  { label: 'Quantities', value: 'quantities' },
  { label: 'SdsURLs', value: 'sdsURLs' },
  { label: 'SecondaryCategories', value: 'secondaryCategories' },
  { label: 'Sizes', value: 'sizes' },
  { label: 'Skus', value: 'skus' },
  { label: 'SourceURLs', value: 'sourceURLs' },
  { label: 'StockNum', value: 'stockNum' },
  { label: 'Taxonomy', value: 'taxonomy' },
  { label: 'TaxonomyLevel1', value: 'taxonomyLevel1' },
  { label: 'TaxonomyLevel2', value: 'taxonomyLevel2' },
  { label: 'TaxonomyLevel3', value: 'taxonomyLevel3' },
  { label: 'TaxonomyLevel4', value: 'taxonomyLevel4' },
  { label: 'TaxonomyLevel5', value: 'taxonomyLevel5' },
  { label: 'TaxonomyLevel6', value: 'taxonomyLevel6' },
  { label: 'TaxonomyLevel7', value: 'taxonomyLevel7' },
  { label: 'TaxonomyLevel8', value: 'taxonomyLevel8' },
  { label: 'TaxonomyLevel9', value: 'taxonomyLevel9' },
  { label: 'Upc', value: 'upc' },
  { label: 'Upca', value: 'upca' },
  { label: 'Upce', value: 'upce' },
  { label: 'Vin', value: 'vin' },
  { label: 'WebsiteIDs', value: 'websiteIDs' },
  { label: 'Weight', value: 'weight' }
]

export const mostCommonFieldsList = [
  { label: 'Prices', value: 'prices' },
  { label: 'Gtins', value: 'gtins' },
  { label: 'Reviews', value: 'reviews' }
]
